
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector, useDispatch } from "react-redux"
import { useEffect, useCallback, useContext, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRows"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import { useEditPatientMutation, useExportPatientsMutation } from "../../slices/patientSlice"
import { handleAddFilterValues, handleSidebarPrvState } from "../../redux/systemConfigSlice"
import AlertsTable from './Component'
import TopBarPatient from "./TopBar"
import { useGetAlertsQuery, useAcknowledgeAlertMutation } from "../../slices/alertSlice"
import Loader from "../../components/Loader"
import { setAlertNotificationSearchApplied } from "../../redux/alerAndNotificationSearchSlice"
import AlertNotificationSearchbar from "./Component/AdvancedSearch"


export default function ManageAlerts() {
    const { setToastmessage, isSearchOpen, setIsSearchOpen, setToastErrorMessage, isSideBar, setIsSideBar } = useContext(GlobalContext);
    const AlertNotificationSearch = useSelector(state => state.AlertNotificationSearchData);
    const [editPatient] = useEditPatientMutation()
    const [exportPatientList] = useExportPatientsMutation()
    const [suggestions, setSuggestions] = useState("")
    const [limit, setLimit] = useState("15")
    const [skip, setSkip] = useState(true)
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading, setLoading] = useState(false)
    const [isSortselected, setisSortSelected] = useState(false)
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({ isOpen: false, rowData: '', multirow: '', user_names: [] });
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [emptyField, setEmptyField] = useState(false);
    const auth = useSelector(state => state?.auth)
    const orgId = useSelector(state => state?.systemConfigData?.organization_id)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const { userType } = auth
    const initialState = {
        "patient_id": "",
        'patient_name': '',
    }
    const [filterValues, setFilterValues] = useState(initialState)
    const [selectedOrganizationName, setSelectedOrganizationName] = useState([{
        patient_name: '',
        patient_id: '',
    }]);
    const [acknowledgeModal, setAcknowledgeModal] = useState(false)
    const [selectedAlert, setSelectedAlert] = useState({})
    const [datePartialFilled,setDatePartialFilled]=useState(false)
    

    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });

    const { data, isFetching, isLoading, status } = useGetAlertsQuery(searchParams?.toString(),{skip: skip||location.search===''})
    const [acknowledge] = useAcknowledgeAlertMutation()
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.limit = 15
        if (key === 'search') { params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '')
            delete params.search
        setSearchParams({ ...params }, { replace: true })
    }


    useEffect(() => {
        if (location.search === '') {
            setSkip(true)
        }
        if (location.state !== null && location.state !== '' && location?.state?.limit !== undefined && !Array.isArray(location.state)) {
            const { user_id, id, ...restState } = location.state
            let params = { limit: '15', page_number: '1', sort: 'created_at+desc', ...restState };
            if (params.search) params.search = decodeURIComponent(params.search)
            else delete params.search
            setSearchParams(params, { replace: true })
            if (params.search_mode && !isSearchOpen) {
                dispatch(handleSidebarPrvState(isSideBar))
                setIsSearchOpen(true)
                setIsSideBar(false)
            }
        }
        else {
            const params = Object.fromEntries(searchParams)
            let changed = false
            if (!params.limit) { params.limit = '15'; changed = true }
            if (!params.page_number) { params.page_number = '1'; changed = true }
            if (changed) setSearchParams(params, { replace: true })
        }

        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')

    }, [location]);

    useEffect(() => {
        if (searchParams.size >= 2) {
            setSkip(false)
        }
        else {
            setSkip(true)
        }
    }, [searchParams])


    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params }, { replace: true });
    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum }, { replace: true })

    }

    useEffect(() => {
        if (data !== undefined) {
            dispatch(limitReducer([data, searchParams.get("limit"), searchParams.get("page_number")]))
        }
    }, [data?.data]);

    useEffect(() => {
        if (searchParams?.get("patient_name") !== null && filtervals?.patient_name !== undefined) {
            setSelectedOrganizationName([{
                patient_name: filtervals['patient_name'],
                patient_id: filtervals['patient_id'],
            }])
        }
    }, [])

    const handleChange = (val) => {
        handleSearchParams('search', val)

    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );


    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if (type) {
            params.filter = "true";
            // Dispatch the filter values to Redux
            dispatch(handleAddFilterValues({
                "patient_id": filterValues.patient_id,
                'patient_name': filterValues.patient_name,
            }));
            params.page_number = 1
            filterValues?.patient_id !== "" && filterValues?.patient_id !== undefined ? params["patient_id"] = filterValues.patient_id : ''
            params.filter = "true";
            setSearchParams({ ...params }, { replace: true });
        } else {
            // Clear filterValues when type is false
            setFilterValues({
                "patient_id": "",
                'patient_name': '',
            });
            // Remove filter-related keys from searchParams
            delete params['filter'];
            params["patient_id"] && delete params["patient_id"]
            if (params["filter"] === "true") {
                delete params["filter"];
            }
            setSearchParams({ ...params }, { replace: true });
        }
    };


    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setAcknowledgeModal(false)
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async (e) => {

        if ((confirmationState?.rowData !== undefined && confirmationState?.rowData !== "" && confirmationState?.rowData?.status === 'active' && textAreaMsg.trim() === '') || (confirmationState?.multirow === "deactive" && (textAreaMsg.trim() === ''))) {
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyField(true)
            return;
        }
        try {
            let body = {}
            if (confirmationState?.rowData !== undefined && confirmationState?.rowData !== "") {
                {
                    confirmationState?.rowData?.status === 'inactive' ?
                        body = {
                            "user_names": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": ''
                        } :
                        body = {
                            "user_names": [confirmationState?.rowData.user_name],
                            "status": confirmationState?.rowData?.status === "inactive" ? "active" : "inactive",
                            "note": textAreaMsg
                        }
                }
            }
            else {
                confirmationState?.multirow === "deactive" ?
                    body = {
                        "user_names": (selectedRows?.filter((user) => user.status !== 'inactive'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": textAreaMsg
                    }
                    :
                    body = {
                        "user_names": (selectedRows?.filter((user) => user.status !== 'active'))?.map((item) => item.name),
                        "status": confirmationState?.multirow === "deactive" ? "inactive" : "active",
                        "note": ''
                    }
            }
            setLoading(true)

            const activationRes = await editPatient({ body })
            setLoading(false)

            if (activationRes?.error) {
                setToastErrorMessage('Something went wrong. Please try again')
            } else {
                if (confirmationState?.multirow !== "" && confirmationState?.multirow !== undefined) {
                    setToastmessage(`Patients ${confirmationState?.multirow === "active" ? "activated" : "deactivated"} successfully`);
                }
                else {
                    setToastmessage(`Patient ${confirmationState?.rowData?.status === "inactive" ? "activated" : "deactivated"} successfully`);
                }
            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})

        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }

    const handleAcknowlegde = (item) => {
        setSelectedAlert(item)
        setAcknowledgeModal(true)
    }

    const handleFinalAcknowledge = async () => {
        setLoading(true)
        const response = await acknowledge(selectedAlert.alert_title)
        if(response){
            setToastmessage(`Alert acknowledged successfully`);
            setAcknowledgeModal(false)
            setLoading(false)
        } else {
            setToastErrorMessage('Something went wrong. Please try again')
            setAcknowledgeModal(false)
            setLoading(false)
        }
    }

    // apply search function
    const handleOnSubmit = (e) => {
        e.preventDefault();
        let searchString = '';
    
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };
    
        const handleField = (field, inverseField, key) => {
            if (AlertNotificationSearch?.[field] && AlertNotificationSearch[field].trim() !== '') {
                const prefix = AlertNotificationSearch?.[inverseField] ? 'ne:' : '';
                const formattedValue = formatSearchValue(AlertNotificationSearch[field]);
                searchString += `${key}=${prefix}${encodeURIComponent(formattedValue)};`;
            }
        };
    
        const handleArrayField = (field, inverseField, key) => {
            if (Array.isArray(AlertNotificationSearch?.[field])) {
                const prefix = AlertNotificationSearch?.[inverseField] ? 'ne:' : '';
                AlertNotificationSearch[field].forEach((value) => {
                    searchString += `${key}=${prefix}${encodeURIComponent(value)};`;
                });
            }
        };
    
        const handleDateField = () => {
            const { created_day, created_month, created_year } = AlertNotificationSearch || {};
            const isPartialDateFilled =
                (created_day && (!created_month || !created_year)) ||
                (created_month && (!created_day || !created_year)) ||
                (created_year && (!created_day || !created_month));
    
            if (isPartialDateFilled) {
                setDatePartialFilled(true);
                return true;
            } else if (
                created_day === '--' &&
                created_month === '--' &&
                created_year === '----'
            ) {
                const datePrefix = AlertNotificationSearch?.acknowledge_date_inverse ? 'ne:' : '';
                searchString += `acknowledged_at=${datePrefix}__NULL__;`;
            } else if (created_day && created_month && created_year) {
                const dateStr = `${created_year}-${String(created_month).padStart(2, '0')}-${String(created_day).padStart(2, '0')}`;
                const date = new Date(`${dateStr}T00:00:00`);
                const epochDate = Math.floor(date.getTime() / 1000);
                const datePrefix = AlertNotificationSearch?.created_date_inverse ? 'ne:' : '';
                searchString += `created_at=${datePrefix}${epochDate};`;
            }
            return false;
        };
    
        const fieldsToCheck = [
            { field: 'alert_title', inverseField: 'alert_title_inverse', key: 'alert_title' },
            { field: 'alert_message', inverseField: 'alert_message_inverse', key: 'alert_message' },
            { field: 'user_id', inverseField: 'user_id_inverse', key: 'sender_user_id' },
            { field: 'user_name', inverseField: 'user_name_inverse', key: 'sender_full_name' },
            { field: 'age', inverseField: 'age_inverse', key: 'age' },
            { field: 'gender', inverseField: 'gender_inverse', key: 'gender' },
        ];
    
        fieldsToCheck.forEach(({ field, inverseField, key }) => {
            handleField(field, inverseField, key);
        });
    
        handleArrayField('alert_severity', 'alert_severity_inverse', 'alert_priority');
    
        if (handleDateField()) {
            return;
        }
    
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
    
        const currentParams = Object.fromEntries(searchParams);
        const newParams = {
            ...currentParams,
            search: searchString || '',
            search_mode: AlertNotificationSearch?.match === false ? 'and' : 'or',
            page_number: 1,
            limit: currentParams.limit || '15',
        };
    
        if (!newParams.search) delete newParams.search;

        setSearchParams(newParams, { replace: true });
        setisSortSelected(false);
        dispatch(setAlertNotificationSearchApplied());
    };
    
    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Alerts"} />
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBarPatient
                            title={'List of Alerts'}
                            SearchInput={((data?.data?.length === 0 && searchParams.get("search") === null) || data === undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add Patient"}
                            menuBar={(data !== undefined && data?.data?.length > 0 && selectedRows?.length > 0) ? true : false}
                            ApplyFilter={true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-patients/add-patients'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID', 'Username', 'First Name', 'Middle Name', 'Last Name', 'Date of Birth', 'Age', 'Status', 'Organization Name', 'Sub Division Name', 'Primary Identifier', 'Secondary Identifier', 'Email Address', 'Created Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportPatient={exportPatientList}
                            filterValues={filterValues}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setFilterValues={setFilterValues}
                            handleApplyFilter={handleApplyFilter}
                        // isIdexport={true}
                        />
                    </div>
                    {((isFetching && status !== "fulfilled" && status !== "rejected" && !isSortselected) || (isLoading) || (data === undefined && status !== "fulfilled" && status !== "rejected")) ? <CustomOverLay Active text="Loading Alerts/Notification list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'opened_sidebar_overlay' : 'overlay-list'}`} /> : (data !== undefined && data?.data?.length > 0) ? <>
                        <div className="px-6">
                            <AlertsTable
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}
                                handleAcknowlegde={handleAcknowlegde}
                            />
                        </div>
                        {data?.total_count >= 15 && <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />

                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </> : <>
                        {(data?.total_count === 0 && searchParams.get('patient_id') !== null) ? (
                            <SearchEmptyScreen text={"That filter combination has no result. Please try different criteria"} />
                        ) : (data?.total_count === 0 && !searchParams.get("patient_id") && !searchParams.get('search') && !searchParams.get('search_mode')) ? (
                            <Emptyscreen
                                title={"Manage Alerts"}
                                FirstPTag={"No Alerts generated yet."}
                            />
                        ) : (data?.total_count === 0 && (searchParams.get('search') || searchParams.get('search_mode'))) ? (
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                        ) : (
                            (status === "rejected" || (data?.total_count !== 0 && data?.data?.length === 0)) && (
                                <SearchEmptyScreen text={"No data found"} />
                            )
                        )}
                    </>}
                </div>
                {isSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <AlertNotificationSearchbar
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                />
                }
                {acknowledgeModal &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                // emptyField={emptyArea}
                                // setEmptyField={setEmptyArea}
                                // setTextAreaMsg={setTextAreaMsg}
                                // textAreaMsg={""}
                                handleOnCLickActivate={handleFinalAcknowledge}
                                handleClose={handleConformationClick}
                                tittle={`Acknowledge`}
                                message={`Are you sure you want to acknowledge this?`}
                                textMessage={true === false ? false : true}
                                buttonName={true && !loading ? "Acknowledge" : <span>{<Loader />}</span>}
                                // CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    />
                }
            </div>
        </>

    )
}